import { fieldType, fieldsGroupType, createFormProps, fieldMode } from 'components/FormCreatorComponent/types';

export const closeAccountTypesForms: createFormProps = {
	name: 'page.customerAccounts.forms.closeAccount',
	handleChange: () => {},
	fieldsGroups: [
		{
			type: fieldsGroupType.row,
			fields: [
				{
					type: fieldType.select,
					mode: fieldMode.readonly,
					props: {
						name: 'contact',
						label: 'page.customerAccounts.closeAccount.closeAccountDialogue.contacts.title',
						options: [{ label: 'Uzi AAA', value: '1' }],
						value: null,
						required: true,
						disabled: false,
					},
					validation: [{ requierd: true }],
				},
				{
					type: fieldType.text,
					props: {
						name: 'reason',
						label: 'page.customerAccounts.closeAccount.closeAccountDialogue.reason.title',
						value: '',
						required: true,
						disabled: false,
					},
					validation: [{ requierd: true }],
				},
			],
		},
		{
			type: fieldsGroupType.row,
			fields: [
				{
					type: fieldType.checkbox,
					props: {
						name: 'agree',
						label: 'page.customerAccounts.closeAccount.closeAccountDialogue.agree.title',
						required: true,
						disabled: false,
					},
					validation: [{ checked: true }],
				},
			],
		},
	],
};
